import { api } from './api.js';
import { TAG_LIST_ROLES, TAG_ROLE } from './tags.js';

export const rolesEndpoints = api.injectEndpoints({
    endpoints: (builder) => ({
        getRoles: builder.query({
            query: () => ({
                url: '/roles',
                method: 'GET'
            }),
            providesTags: [TAG_LIST_ROLES],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        deleteRole: builder.mutation({
            query: (id) => ({
                url: `/roles/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [TAG_LIST_ROLES],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        addRole: builder.mutation({
            query: (data) => ({
                url: '/roles/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_ROLES],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getRole: builder.query({
            query: (id) => ({
                url: `/roles/view/${id}`,
                method: 'GET'
            }),
            providesTags: [TAG_ROLE],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        editRole: builder.mutation({
            query: ({ id, data }) => ({
                url: `/roles/edit/${id}`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_ROLES, TAG_ROLE],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getRoleTypes: builder.query({
            query: () => ({
                url: '/misc/role-types',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getRolePermissions: builder.query({
            query: () => ({
                url: '/misc/permissions',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getUserAssignableRoles: builder.query({
            query: (id) => ({
                url: `/misc/assignable-roles/${id}`,
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});

export const {
    useGetRolesQuery,
    useDeleteRoleMutation,
    useAddRoleMutation,
    useGetRoleQuery,
    useEditRoleMutation,
    useGetRoleTypesQuery,
    useGetRolePermissionsQuery,
    useGetUserAssignableRolesQuery
} = rolesEndpoints;
